import type {
  BulkOperationResponseBody,
  DataGridBulkActionsResponseBody,
} from '../types/api/bulkOperations';

export function isBulkOperationSupportedByGrid(
  operation: Pick<BulkOperationResponseBody, 'resourceId' | 'actionCode'>,
  discovery: DataGridBulkActionsResponseBody
): boolean {
  return (
    operation.resourceId === discovery.resourceId &&
    discovery.actions.some((action) => action.actionCode === operation.actionCode)
  );
}
